<form
  class="connect-bg connect-channel"
  (ngSubmit)="addTelegram()"
  #telegramForm="ngForm"
  name="telegramForm"
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
>
  <h2>{{ titleText }}</h2>
  <h3>{{ step1TitleText }}</h3>
  <p>
    {{ step1IntroText }}
    <a href="https://telegram.me/BotFather" target="_blank">{{
      step1LinkText
    }}</a
    >{{ step1OutroText }}
  </p>
  <p>
    {{ botUsernameInfoText }}
  </p>
  <h3>{{ step2TitleText }}</h3>
  <mat-form-field fxFlex>
    <input
      fxFlex
      matInput
      [(ngModel)]="telegramChannel.telegramBotName"
      #telegramName="ngModel"
      name="telegramName"
      type="text"
      [placeholder]="botUsernamePlaceholder"
      required
    />
  </mat-form-field>

  <mat-form-field fxFlex>
    <input
      fxFlex
      matInput
      [(ngModel)]="telegramChannel.telegramBotToken"
      #telegramBotToken="ngModel"
      name="telegramBotToken"
      type="text"
      [placeholder]="tokenPlaceholder"
      [pattern]="pattern"
      required
    />
    <mat-hint align="start"
      ><strong>{{ tokenHintText }}</strong></mat-hint
    >
  </mat-form-field>

  <button
    mat-raised-button
    fxFlex="none"
    type="submit"
    [disabled]="!telegramForm.form.valid"
  >
    {{ connectBotText }}
  </button>
</form>
